import { Field } from "formik";
import React, { Component } from "react";
import "./login.scss";

class ClearableField extends Component {
  constructor(props) {
    super(props);

    this.state = {
      validation: this.props.validation || (() => true),
      visiblePassword: false
    };
  }

  render() {
    return (
      <Field name={this.props.name}>
        {({
          field,
          form: {
            setFieldValue,
            setFieldTouched,
            setFieldError,
            touched,
            errors,
          },
        }) => {
          const VALID =
            !errors[field.name] &&
            (!touched[field.name] || this.state.validation(field.value));

          return (
            <div className="embed-submit-field" id={this.props.id}>
              <input
                disabled={this.props.disabled}
                autoComplete={this.props.autoComplete}
                type={(this.props.type === 'password' && this.state.visiblePassword ? "text" : (this.props.type || "text"))}
                placeholder={this.props.placeholder}
                {...field}
                className={"form-control" + (VALID ? "" : " invalid")}
              />
              {field.value && !this.props.disabled && (
                <button
                  type="button"
                  className={VALID ? "" : "invalid"}
                  onClick={() => {
                    setFieldValue(field.name, "", false);
                    setFieldTouched(field.name, false, true);
                    setFieldError(field.name, "");
                  }}
                >
                  &#x2715;
                </button>
              )}
              {field.value && this.props.type === 'password' && (
                <button
                  type="button"
                  className={'password-visibility'}
                  onClick={() => {
                    this.setState({
                      visiblePassword: !this.state.visiblePassword
                    })
                  }}
                >
                  <i className={this.state.visiblePassword ? "fa fa-eye-slash" : "fa fa-eye"}></i>
                </button>
              )}
            </div>
          );
        }}
      </Field>
    );
  }
}

export default ClearableField;
